import { Box, Dialog, DialogContent } from "@mui/material";
import type { ReactNode } from "react";

import { APPROVAL_DIALOG, NEUTRAL } from "../../theme/tokens";

export const StyledStyledDialog = ({ children }: { children: ReactNode }) => (
	<DialogContent
		sx={{
			p: 0,
			m: 0,
			px: 0,
			overflowY: "auto",
			flex: "1 1 auto",
			display: "flex",
			flexDirection: "column",
			"&::-webkit-scrollbar": {
				width: "8px",
				height: "8px",
			},
			"&::-webkit-scrollbar-track": {
				backgroundColor: NEUTRAL[100],
				borderRadius: "4px",
			},
			"&::-webkit-scrollbar-thumb": {
				backgroundColor: NEUTRAL[400],
				borderRadius: "4px",
				"&:hover": {
					backgroundColor: NEUTRAL[500],
				},
			},
			scrollbarWidth: "thin",
			scrollbarColor: "#c1c1c1 #f1f1f1",
		}}
	>
		{children}
	</DialogContent>
);

export const NurseTableBox = ({ children }: { children: ReactNode }) => (
	<Box
		sx={{
			marginTop: 0,
			p: 0,
			m: 0,
			width: "100%",
			// Definite height (viewport-based, so it always resolves) + no shrink: the child SystemDataGrid
			// relies on a definite-height ancestor to resolve its `height: 100%` and scroll internally. With
			// only `maxHeight` here the height was indefinite, so an all-rows grid rendered full-height and
			// overflowed the box (overlapping the dialog's footer actions).
			flexShrink: 0,
			display: "flex",
			flexDirection: "column",
			minHeight: "100px",
			height: "calc(80vh - 200px)",
		}}
	>
		{children}
	</Box>
);

export const StyledDialog = ({
	open,
	onClose,
	children,
	"data-testid": dataTestId,
}: {
	open: boolean;
	onClose: () => void;
	children: ReactNode;
	"data-testid"?: string;
}) => (
	<Dialog
		open={open}
		onClose={onClose}
		data-testid={dataTestId}
		maxWidth="md"
		slotProps={{
			paper: {
				sx: {
					borderRadius: "8px",
					boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
					minHeight: "300px",
					maxHeight: APPROVAL_DIALOG.MAX_HEIGHT,
					display: "flex",
					flexDirection: "column",
					maxWidth: "96vw !important",
					width: "1200px",
				},
			},
		}}
	>
		{children}
	</Dialog>
);
